/**
 * Copyright 2024-2025 Wingify Software Pvt. Ltd.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Connector } from './Connector';

// TODO: move to file
// enum ConnectorEnum {
//   MEMORY = 'memory',
//   REDIS = 'redis'
// }

export class Storage {
  public static instance: Storage;
  public connector: Connector | Record<any, any>; // RedisConnector |
  // public storageType: dynamic;

  public attachConnector(connector: any): any {
    if (connector?.prototype?.constructor?.toString()?.trim()?.substring(0, 5) === 'class') {
      this.connector = new connector();
    } else {
      this.connector = connector;
    }

    return this.connector;
  }

  public static get Instance(): Storage {
    this.instance = this.instance || new Storage();

    return this.instance;
  }

  public getConnector(): any {
    return this.connector;
  }
}
